import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatButtonModule } from '@angular/material/button';

interface BtnCellRendererParams extends ICellRendererParams {
  onClick: any;
  label?: string;
  btnColor?: string;
  display?: string;
}

@Component({
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
    ],
    selector: 'app-button-renderer',
    template: `
    <ng-container *ngIf="visible">
      <button
        *ngIf="buttonType === 'mat-stroked-button'; else flatBtn"
        mat-stroked-button
        [color]="btnColor"
        [ngClass]="{'compact': compact}"
        (click)="onClick($event)">
        {{ label }}
      </button>
      <ng-template #flatBtn>
        <button
          mat-flat-button
          [color]="btnColor"
          [ngClass]="{'compact': compact}"
          (click)="onClick($event)">
          {{ label }}
        </button>
      </ng-template>
    </ng-container>`,
    styles: [
        `.compact {
      height: 24px;
    }`,
    ]
})
export class BtnCellRenderer implements ICellRendererAngularComp {
  @Input() params: BtnCellRendererParams;
  label: string | null;
  btnColor: string;
  visible: boolean = true;
  compact: boolean = false;
  buttonType: string;

  agInit(params: BtnCellRendererParams & { label?: string; buttonType?: string }): void {
    this.params = params;
    this.label = this.params.label || '';
    this.btnColor = this.params.btnColor || 'primary';
    this.compact = params.display === 'compact';
    this.buttonType = params.buttonType || 'mat-flat-button'; // Default to mat-flat-button if no buttonType is given
    this.setupVisibility();
  }

  setupVisibility(): void {
    const type = this.params?.data?.type;
    const status = this.params?.data?.status;
    const expiresAt = this.params?.data?.expiresAt;
    const state = this.params?.data?.status?.state;

    if (
      type === 'identity#invitation' &&
      (status !== 'pending' || new Date(expiresAt) < new Date())
    ) {
      this.visible = false;
    }

    if (type === 'crm' && state !== 'done') {
      this.visible = false;
    }
  }

  refresh(): boolean {
    return true;
  }

  onClick($event: MouseEvent): void {
    const params = {
      event: $event,
      rowData: this.params.node.data,
    };
    this.params.onClick(params);
  }
}
